<template>
  <vs-row vs-w="12"
          class="height-full-screen">

    <vs-col vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="4"
            vs-sm="12"
            vs-xs="12"
            class="bg-primary-gradient">

      <Promo class="height-full-screen"/>

    </vs-col>
    <vs-col vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-lg="8"
            vs-sm="12"
            vs-xs="12"
            class="bg-white">

      <vs-row class="height-full-screen">
        <div style="min-height: 1px; min-width: 1px"/>

        <UserUploadFlow/>

        <div class="d-flex align-items-end mr-auto ml-auto full-width">
          <p class="d-flex justify-content-end full-width">
            <a class="p-5" href="https://skanerchf.pl/privacy">Polityka Prywatności</a>
            <a class="p-5" href="https://skanerchf.pl/terms">Regulamin Serwisu</a>
          </p>
        </div>

      </vs-row>

    </vs-col>


  </vs-row>
</template>

<script>
import UserUploadFlow from "@/views/components/UserUploadFlow";
import Promo from "@/views/components/Promo";

export default {
  name: "InitialUserView",
  components: {
    UserUploadFlow, Promo
  }
}
</script>

<style>
.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: space-between;
}

.align-items-end {
  align-items: flex-end;
}
</style>
